export const enum LayoutMode {
    Default = 1,
    Map = 2,
    Admin = 3,
    None = 4
}